'use strict';

var domUtil = require('../domUtil');
var customUtil = require('../customUtil');
var slickHelper = require('../utils/slick');
var viewportUtil = require('../utils/viewport');
var baseHelper = require('./base');
var formValidation = require('../components/formValidation');
var csrf = require('../csrf');
var hiddenClass = 'd-none';

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {int} price - product sale price
 * @param {int} standardPrice - product standard price
 * @param {string} percentOffMark - string value
 * @param {Object} productContainer - DOM container for a given product
 * @param {boolean} hasSalePricebook - has sale pricebook
 */
function updateProductPrice(price, standardPrice, percentOffMark, productContainer, hasSalePricebook, salesPriceBeforePromo) {
    var priceTemplate = $('.price-template')[0].cloneNode(true);
    var priceSection = domUtil.queryFirst('.prices .price', productContainer);
    var priceContainer = domUtil.queryFirst('.price-section', priceTemplate);
    var strikeThroughContainer = domUtil.queryFirst('.strike-through-section', priceContainer);
    var priceElement = domUtil.queryFirst('.strike-through-price', strikeThroughContainer);
    var salesContainer = domUtil.queryFirst('.sales', priceContainer);
    var salesPriceElement = domUtil.queryFirst('.price-value', salesContainer);
    var salesBeforPromoElement = domUtil.queryFirst('.sales-before-promo', priceContainer);
    var percentOffContainer = domUtil.queryFirst('.sales-percentage', priceContainer);
    var percentOffElement = domUtil.queryFirst('.percent-value', priceContainer);
    domUtil.removeClass(strikeThroughContainer, hiddenClass);

    if (!hasSalePricebook) {
        domUtil.addClass(strikeThroughContainer, hiddenClass);
        domUtil.addClass(percentOffContainer, hiddenClass);
    }

    if (salesBeforPromoElement && salesPriceBeforePromo) {
        salesBeforPromoElement.textContent = salesPriceBeforePromo;
    }

    if (priceElement) {
        priceElement.textContent = standardPrice;
    }
    if (salesPriceElement) {
        salesPriceElement.textContent = price;
    }
    if (price === standardPrice) {
        domUtil.addClass(strikeThroughContainer, hiddenClass);
    }
    if (price < standardPrice && percentOffElement && percentOffMark) {
        percentOffElement.textContent = percentOffMark;
    }
    priceSection.innerHTML = priceTemplate.innerHTML;
}

/**
 * This method used to get the pdp estimated delivery date via ajax call
 * @param {string} inStockDate - In Stoke date
 */
function getPdpEDD(inStockDate) {
    var $eddText = $('.eddtext.productDetails');
    var $eddPidDiv = $eddText.find('.eddpid');

    if ($eddPidDiv.length) {
        var url = $eddPidDiv.data('url');

        if (url) {
            var eddObj = {
                zipcode: $eddPidDiv.data('narvar-dest-zip'),
                carrierCode: $eddPidDiv.data('narvar-carrier-code'),
                serviceCode: $eddPidDiv.data('narvar-service-code'),
                inStockDate: inStockDate
            };

            $eddText.addClass('d-none');

            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: { eddObj: JSON.stringify(eddObj) },
                success: function(data) {
                    if (data.success) {
                        $eddPidDiv.closest('.eddtext').attr('data-object', JSON.stringify(data.eddObject));
                        if (eddObj.serviceCode && eddObj.serviceCode.length > 0 && eddObj.carrierCode && eddObj.carrierCode.length > 0) {
                            $eddPidDiv.text('');
                            if (window.narvar) {
                                window.narvar('getEdd', {});
                            }
                        } else if (data.earliestEDD) {
                            $eddPidDiv.text(data.earliestEDD);
                            if (window.narvar) {
                                window.narvar('getEdd', {});
                            }
                        } else if (window.narvar) {
                            window.narvar('getEdd', {});
                        }
                    } else if (window.narvar) {
                        window.narvar('getEdd', {});
                    }
                    var limit = 0;
                    var timeInt;
                    var unHideEdd = function() {
                        if ($eddPidDiv.text().trim().length > 0 || limit > 100) {
                            if ($eddPidDiv.text().trim().length > 0) {
                                $eddText.removeClass('d-none');
                            }
                            clearTimeout(timeInt);
                        } else {
                            limit++;
                            timeInt = setTimeout(unHideEdd, 100);
                        }
                    };
                    unHideEdd();
                }
            });
        }
    }
}

/**
 * This method handles the unavailability message in product set
 */
function handleSetUnavailabilityMessage() {
    var unavailableItems = $('.availability-container .no-stock').length;
    var setUnavailableMessageOne = $('.set-unavailable-message-one');
    var setUnavailableMessageMany = $('.set-unavailable-message-many');
    if (unavailableItems > 1) {
        setUnavailableMessageOne.addClass('d-none');
        setUnavailableMessageMany.find('.no-of-items').text(unavailableItems);
        setUnavailableMessageMany.removeClass('d-none');
    } else if (unavailableItems === 1) {
        setUnavailableMessageMany.addClass('d-none');
        setUnavailableMessageOne.removeClass('d-none');
    } else {
        setUnavailableMessageOne.addClass('d-none');
        setUnavailableMessageMany.addClass('d-none');
    }
}

$('body').on('product:afterAttributeSelect', function(e, data) {
    if (data.attributeType && data.attributeType === 'color') {
        if (data.data.product.recommendationsHtml) {
            $('.recommendations-products').empty();
            $('.product-recommendation-details')
                .empty()
                .html(data.data.product.recommendationsHtml);
            $('body').trigger('search:updateProducts');
        }
        if (data.data.product.einsteinProductRecommendationsHtml) {
            $('.custom-recommender')
                .empty()
                .html(data.data.product.einsteinProductRecommendationsHtml);
            $('body').trigger('search:updateProducts');
        } else {
            $('.custom-recommender').empty();
        }
    }
    if ($('.product-detail.product-pdp .custom-select-wrapper .size-value.selected').length) {
        $('.qty-err').remove();
    }
    if (!data.data.product.price.type) {
        var standardPrice = data.data.product.price.list ? data.data.product.price.list.formatted : data.data.product.price.sales.formatted;
        var price = standardPrice;
        var percentOffMark;
        if (data.data.product.price.sales) {
            price = data.data.product.price.sales.formatted;
        }
        if (data.data.product.price.list) {
            percentOffMark = data.data.product.price.percentageOff;
        }

        var hasSalePricebook = data.data.hasSalePricebook;
        var salesPriceBeforePromo =
            'salesBeforePromo' in data.data.product.price && data.data.product.price.salesBeforePromo ? data.data.product.price.salesBeforePromo.formatted : '';
        updateProductPrice(price, standardPrice, percentOffMark, data.container[0], hasSalePricebook, salesPriceBeforePromo);
    }
    var isPdpSet = $('.product-set-detail').length;
    if (isPdpSet) {
        handleSetUnavailabilityMessage();
    }

    var PdpVideoID = data.data.product.pdpVideoID;
    if (PdpVideoID !== null && PdpVideoID !== undefined) {
        var carousel = $('.product-detail .primary-images .carousel');
        if (isPdpSet) {
            var selectedProductID = data.data.product.id;
            if (selectedProductID !== null && selectedProductID !== undefined) {
                $('.product-detail').each(function() {
                    var setItemID = $(this)
                        .find('.product-id.bfx-sku')
                        .text();
                    if (setItemID === selectedProductID) {
                        carousel = $(this).find('.carousel');
                    }
                });
            }
        }

        if ($(carousel).length > 0) {
            var carouselId = $(carousel).attr('id');
            var imageLength = $(carousel).find('.carousel-inner .carousel-item ').length;
            $(
                '<div class="carousel-item pdp-video-container"><iframe src="https://player.vimeo.com/video/' +
                    PdpVideoID +
                    '?background=1&amp;muted=1&amp;controls=0&amp;autoplay=1&amp;loop=1&amp;autopause=0&amp;quality=1080p" width="auto" frameborder="0" allowfullscreen="" data-widths="[0]"></iframe></div>'
            ).appendTo($(carousel).find('.carousel-inner'));
            $('<li data-target="#' + carouselId + '" data-slide-to="' + imageLength.toFixed() + '" class=""></li>').appendTo(
                $(carousel).find('.carousel-indicators')
            );
        }
    }
    // update Narvar estimated date on PDP
    var $eddPidDiv = $('.eddpid');
    if (isPdpSet) {
        var selectedEddProductID = data.data.product.id;
        if (selectedEddProductID !== null && selectedEddProductID !== undefined) {
            $('.product-detail').each(function() {
                var setItemID = $(this)
                    .find('.product-id.bfx-sku')
                    .text();
                if (setItemID === selectedEddProductID) {
                    $eddPidDiv = $(this).find('.eddpid');
                }
            });
        }
    }
    if ($eddPidDiv.length > 0) {
        if (data.data.product.availability.eddPreOrderDate) {
            $eddPidDiv.attr('data-narvar-instock-date', data.data.product.availability.eddPreOrderDate);
            $eddPidDiv.addClass('preorder-date');
            if ($('.pdp-edd.hide').length > 0) {
                $('.pdp-edd.hide').removeClass('hide');
            }
        } else {
            if ($eddPidDiv.hasClass('preorder-date')) {
                $eddPidDiv.removeClass('preorder-date');
            }
            if ($('.pdp-edd.hide').length > 0) {
                $('.pdp-edd.hide').removeClass('hide');
            }
        }

        getPdpEDD(data.data.product.availability.eddPreOrderDate);
    }

    /* re-renders the applicable promotions if the product has active product-level promotions */
    var $targetEl = $('.applicable-promotions');
    if (data.data.product.hasPromotions) {
        var promotions = data.data.product.promotions;
        baseHelper.updateProductPromotions($targetEl, promotions);
    } else {
        $targetEl.empty();
    }
});

// calculate the top offset of product details description container and lock it at the top once the 'Add to bag' button is in the viewport
var setProductDetailsDescTop = function(parentEl) {
    if (!parentEl) {
        return;
    }

    var $productDescContainer = parentEl.find('.product-description-container');
    var $btnContainer = parentEl.find('.prices-add-to-cart-actions');
    var woh = $(window).outerHeight(true);
    var bPadding = 50;
    var topOffset = 150;

    if ($btnContainer.length > 0 && !viewportUtil.isInViewport($btnContainer)) {
        topOffset = woh - ($btnContainer.position().top + $btnContainer.outerHeight(true) + bPadding);
    }

    $productDescContainer.css({ top: topOffset / 16 + 'rem' });
};

$('body').on('product:updateAvailability', function(e, data) {
    var className = data.product.availability.classType;
    var errMessage = data.product.availability.messages[0];
    var ele = $(e.target).find('.product-description');
    var isSetItem = data.$productContainer.hasClass('product-detail set-item');
    if (className === 'qty-err') {
        ele.find('.add-to-cart').prop('disabled', true);
    } else {
        ele.find('.add-to-cart').prop('disabled', false);
    }
    if (data.product.variationAttributes) {
        var output = [];
        $.each(data.product.variationAttributes, function(key, variationAttribute) {
            if (variationAttribute.id === 'color') {
                $.each(variationAttribute.values, function(key1, value) {
                    var $colorSelector = $(
                        '.product-detail [data-attr="' +
                            variationAttribute.id +
                            '"] button.' +
                            variationAttribute.id +
                            '-attribute[data-variationgroupid="' +
                            value.variationGroupID +
                            '"]'
                    );
                    if (!value.selectable && (!value.enableBackInStockNotification || isSetItem)) {
                        $colorSelector.attr('disabled', 'disabled');
                    } else {
                        $colorSelector.removeAttr('disabled');
                    }
                    if (!value.enableBackInStockNotification || isSetItem) {
                        $colorSelector.removeClass('back-in-stock-notification');
                    } else {
                        $colorSelector.addClass('back-in-stock-notification');
                    }
                });
            }
            if (variationAttribute.id === 'size') {
                $.each(variationAttribute.values, function(key1, value) {
                    var showBackInStockModule = value.enableBackInStockNotification;
                    output.push(
                        '<button class="' +
                            variationAttribute.id +
                            '-attribute ' +
                            (!value.selectable && showBackInStockModule && !isSetItem ? 'show-backinstock-module' : '') +
                            '" ' +
                            'role="radio" ' +
                            'aria-label="' +
                            value.displayValue +
                            '" ' +
                            'aria-checked="' +
                            (value.selected ? 'true' : 'false') +
                            '" ' +
                            'data-url="' +
                            value.url +
                            '" ' +
                            'data-attr-value="' +
                            value.value +
                            '" ' +
                            'data-value-id="' +
                            value.value +
                            '" ' +
                            (!value.selectable && (!value.enableBackInStockNotification || isSetItem) ? 'disabled' : '') +
                            '>' +
                            '<span data-attr-value="' +
                            value.value +
                            '" ' +
                            'data-attr-displayvalue="' +
                            value.displayvalue +
                            '" ' +
                            'class="' +
                            variationAttribute.id +
                            '-value ' +
                            (value.selected ? 'selected ' : '') +
                            (value.selectable ? 'selectable' : 'unselectable') +
                            '">' +
                            value.displayValue +
                            '</span>' +
                            '</button>'
                    );

                    if (value.selected && !value.selectable) {
                        ele.find('button.add-to-cart').prop('disabled', true);
                    }
                });
                ele.find('[data-attr="' + variationAttribute.id + '"] .size-selections').html(output.join(''));
            }
        });
    }

    // Back in Stock Notification
    $('.notify-sign-up').addClass('hide');
    $('#waitListJoin').removeClass('is-invalid');
    $(this)
        .closest('.product-detail')
        .find('.btn-container')
        .removeClass('hide');

    if (
        ele
            .closest('.product-detail')
            .find('[data-attr="size"] .size-attribute[aria-checked="true"]')
            .hasClass('show-backinstock-module')
    ) {
        ele.closest('.product-detail')
            .find('.add-to-cart')
            .addClass('hide');
        ele.closest('.product-detail')
            .find('.backinstock-notify')
            .removeClass('hide');
    } else {
        ele.closest('.product-detail')
            .find('.btn-container')
            .removeClass('hide');
        ele.closest('.product-detail')
            .find('.add-to-cart')
            .removeClass('hide');
        ele.closest('.product-detail')
            .find('.backinstock-notify')
            .addClass('hide');
    }

    $(ele)
        .find('.color-value')
        .each(function(d, el) {
            if ($(el).hasClass('unselectable')) {
                if (
                    !$(el)
                        .parent()
                        .hasClass('back-in-stock-notification')
                ) {
                    $(el)
                        .parent()
                        .attr('disabled', true);
                } else {
                    $(el)
                        .parent()
                        .attr('disabled', false);
                }
            } else {
                $(el)
                    .parent()
                    .attr('disabled', false);
            }
        });
    $(ele)
        .find('.color-value')
        .parent('.color-attribute')
        .attr('aria-checked', 'false');
    $(ele)
        .find('.color-value.selected')
        .parent('.color-attribute')
        .attr('aria-checked', 'true');
    var colorName = $(ele)
        .find('.color-value.selected')
        .data('attr-displayvalue');
    if (typeof colorName !== 'undefined') {
        $(ele)
            .find('.selected-color')
            .text(colorName.toLowerCase());
    }

    if (className !== 'no-stock') {
        $(ele)
            .find('.product-availability')
            .html('<div class="col-12 message ' + className + '">' + errMessage + '</div>');
        $(ele)
            .find('.cart-and-ipay')
            .removeClass('hide');
    } else {
        $(ele)
            .find('.product-availability')
            .empty();
        $(ele)
            .find('.notify-sign-up .form-group, .notify-sign-up .btn.stock-notify-signup-email, .notify-sign-up.title')
            .removeClass('hide');
        $(ele)
            .find('.notify-sign-up .btn.stock-notify-signup-success')
            .addClass('hide');
    }

    if (className !== 'no-err') {
        $('#footercontent').addClass('message');
    } else {
        $('#footercontent').removeClass('message');
    }

    var preOrderLabel = $('.add-to-cart-btn-labels').attr('data-value-preorder-text');
    var addToCartLabel = $('.add-to-cart-btn-labels').attr('data-value-cart-text');
    var hasPreorder = data.product.availability.messages[0].indexOf('pre-order-ship-msg') >= 0;

    if (hasPreorder) {
        $(ele)
            .find('.add-to-cart span')
            .text(preOrderLabel);
        $(ele)
            .find('.availability')
            .hide();
        $(ele)
            .find('.availability-container .availability-msg')
            .show();
    } else {
        $(ele)
            .find('.add-to-cart span')
            .text(addToCartLabel);
        $(ele)
            .find('.availability')
            .show();
        $(ele)
            .find('.availability-container .availability-msg')
            .hide();
    }
    $(ele)
        .find('.product-desc .content')
        .html(data.product.shortDescription);
    $(ele)
        .find('.description-and-detail')
        .empty()
        .html(data.product.descriptionAndDetailsHtml);
    $(ele)
        .find('.sales-bdg')
        .empty()
        .html(data.product.saleBadgingHtml);
    $(ele)
        .find('.ex-promotion')
        .empty()
        .html(data.product.exclusiveBadgingHtml);
    $(ele)
        .find('.product-name')
        .empty()
        .html(data.product.productName);

    // reset and re-calculate the top offset when color/size is changed
    var $productDescContainer = $('.product-detail .product-description-container');
    $productDescContainer.removeAttr('style');

    if (!customUtil.isMobile() && $('.product-detail').length > 0) {
        setProductDetailsDescTop($('.product-detail'));
    }
});

// adding error message when size not selected
// eslint-disable-next-line consistent-return
$('body').on('product:beforeAddToCart', function(data, ele) {
    var isPdpSet = $(ele).closest('.product-set-detail').length;
    if (isPdpSet) {
        var noSelectionCount = 0;
        var $setProducts = $(ele)
            .closest('.product-detail')
            .find('.set-item');
        if (!$setProducts.length) {
            $setProducts = $(ele).closest('.product-detail.set-item');
        }
        $setProducts.each(function() {
            var $setProduct = $(this);
            var labelText = $setProduct.find('.size-selections').attr('data-value-select-size-label');
            var errorMessage = '<div class="col-9 message qty-err"><p>' + labelText + '</p></div>';
            var $sizeSelected = $setProduct.find('.custom-select-wrapper .size-selections .size-value.selected');
            if ($sizeSelected.length === 0) {
                noSelectionCount++;
                $setProduct
                    .find('.product-description')
                    .find('.availability')
                    .empty()
                    .html(errorMessage);

                $setProduct.find('.select-size').focus();
                $setProduct.find('.add-to-cart').prop('disabled', true);
            }
        });
        if (noSelectionCount > 0) {
            $(ele)
                .closest('.product-set-detail')
                .find('.add-to-cart-global')
                .prop('disabled', true);
            return false;
        }
    } else {
        var $productDetail = $(ele).closest('.product-detail');
        if (!$productDetail.length) {
            return false;
        }
        var selectedVal = $productDetail.find('.custom-select-wrapper .size-value.selected').data('attr-value');
        var $container = $(ele).closest('.product-detail');
        var labelText = $('.size-selections').attr('data-value-select-size-label');
        var errorMessage = '<div class="col-9 message qty-err"><p>' + labelText + '</p></div>';
        if ((selectedVal === undefined || selectedVal === 'undefined') && !isPdpSet) {
            data.preventDefault();
            if (customUtil.isMobile() || $('.availability').css('display') === 'none') {
                $container.find('.availability').show();
                $('#footercontent').addClass('message');
            }
            $container
                .find('.availability')
                .empty()
                .html(errorMessage);

            if ($('.desktop-menu').hasClass('d-none')) {
                $('body, html').animate({
                    scrollTop:
                        $('.size-container').offset().top -
                        ($(window).innerHeight() + $('.prices-add-to-cart-actions').innerHeight()) / 2 +
                        $('.size-container').innerHeight()
                });
            }

            $container.find('.select-size').focus();
            $container.find('.add-to-cart').prop('disabled', true);
            return false;
        }
    }
    handleSetUnavailabilityMessage();
    return false;
});

var expandSizeGuide = function() {
    var sizeGuideAccordion = '.sizeGuide-expand-all';
    $(sizeGuideAccordion).toggleClass('expand');
    if ($(sizeGuideAccordion).hasClass('expand')) {
        $('.pdp-sizeGuide-modal-body > div').addClass('active');
    } else {
        $('.pdp-sizeGuide-modal-body > div').removeClass('active');
    }
    $(sizeGuideAccordion).text($(sizeGuideAccordion).text() === 'Collapse all' ? 'Expand all' : 'Collapse all');
};

$(document).on('click', '.sizeGuide-expand-all', function(e) {
    e.preventDefault();
    expandSizeGuide();
});

var collapseSizeGuide = function() {
    $('.pdp-sizeGuide-modal-body > div').removeClass('active');
    $('.sizeGuide-expand-all')
        .removeClass('expand')
        .text(' Expand all');
};

$(document).on('click', '.sizeGuide-link', function() {
    $('.product-detail').addClass('sizeGuideShow');
});

$(document).on('hidden.bs.modal', '#pdp-sizeGuide', function() {
    $('.product-detail').removeClass('sizeGuideShow');
    setProductDetailsDescTop();
    collapseSizeGuide();
});

var historyPushCount = 0;
var toTitleCase = function(phrase) {
    return phrase
        .toLowerCase()
        .split(' ')
        .map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
};

$(document).on('click', '.color-attribute', function() {
    var $this = $(this);
    var groudId = $(this).data('variationgroupid');
    var isPdp = $(this)
        .closest('.product-detail')
        .hasClass('product-wrapper');
    var pageTitle = document.title;
    var color = $(this)
        .find('.color-value')
        .data('attr-value');
    var productName = $(this)
        .closest('.product-detail')
        .find('.product-name')
        .text();
    var exclusiveBadge = $this.data('exclusivebadge');
    var salesBadge = $this.data('salesbadge');
    var $jsProductTile = $this.closest('.js-product-tile');
    var currentLocale = $(this).data('currentlocale');

    if (isPdp) {
        var newPageUrl = groudId + '.html';
        if (currentLocale && currentLocale !== 'default') {
            newPageUrl = newPageUrl + '?lang=' + currentLocale;
        }
        window.history.pushState('data', 'Title', newPageUrl);
        // update the canonical tag
        $('[rel="canonical"]').attr('href', window.location.href);

        if (pageTitle.split('|').length > 0) {
            // update the page title
            var newPageTitle = pageTitle
                .trim()
                .split('|')
                .map(function(item, index) {
                    // only update the product name in the title
                    if (index === 0) {
                        // concatinate the product color
                        item = toTitleCase(productName + ' In ' + color);
                    }
                    return item;
                })
                .join(' | ');

            document.title = newPageTitle;
        }
        historyPushCount++;
    }

    // check if exclusive/sales badge has data value
    if (exclusiveBadge || salesBadge) {
        var badgeClass = 'badge-product';
        var badgeValue = salesBadge;
        var $targetEl = $jsProductTile.find('.product-detail');

        if (!salesBadge && exclusiveBadge) {
            badgeClass = 'badge-product badge-exclusive';
            badgeValue = exclusiveBadge;
        }

        // check if badge element not exist
        if ($jsProductTile.find('.badge-product').length === 0) {
            // create badge element and append to the target element
            var $newEl = $('<div/>', {
                class: badgeClass
            }).html('<span>' + badgeValue + '</span>');
            $targetEl.append($newEl);
        } else {
            // update the badge element value
            $targetEl.find('.badge-product span').text(badgeValue);
        }
    }
});

if ($('.product-pdp').length > 0) {
    $(window).on('popstate', function() {
        if (historyPushCount > 0) {
            window.history.go(-historyPushCount);
        }
    });
}

var pdpSizeGuideTitleClick = function() {
    if ($('.pdp-sizeGuide-modal-body .collapsible-xs.active').length === $('.pdp-sizeGuide-modal-body .collapsible-xs').length) {
        expandSizeGuide();
    } else if ($('.pdp-sizeGuide-modal-body .collapsible-xs.active').length === 0) {
        collapseSizeGuide();
    }
};

$(document).on('click', '#pdp-sizeGuide .collapsible-xs .title', pdpSizeGuideTitleClick);

if ($('.thumbnail-carousel').length > 0) {
    $('body').on('click', '.thumbnail-carousel__item', function() {
        var $this = $(this);
        // todo remove a as wrapper here in base.js and in thumnailCarousel
        var imgThumbnailIndex = $this.find('img').data('index');
        var activeClass = 'thumbnail-carousel__item--active';
        $('.thumbnail-carousel__item').removeClass(activeClass);
        $('.carousel-item.active').removeClass('active');

        /* display the selected thumbnail image into the large image */
        $('.pdp-carousel .primary-images .carousel').carousel(imgThumbnailIndex);
        $('#carousel-item-' + imgThumbnailIndex)
            .addClass('active')
            .scroll();
        $this.addClass(activeClass);
    });
}

$('body').on('click', '.backinstock-notify', function() {
    var scrollToBISModule = function scrollIntoView(node) {
        var parent = node.parentElement;
        var parentCHeight = parent.clientHeight;
        var parentSHeight = parent.scrollHeight;
        // Doesn't scroll if parent element is body
        if (parentSHeight > parentCHeight && parent.parentElement) {
            var nodeHeight = node.clientHeight;
            var nodeOffset = node.offsetTop;
            var scrollOffset = nodeOffset + nodeHeight / 2 - parentCHeight / 2;
            parent.scrollTop = scrollOffset;
        }
        if (parent.parentElement) {
            scrollIntoView(parent);
        }
    };

    scrollToBISModule(document.querySelector('.product-description-container .attributes'));
    $('.notify-sign-up').removeClass('hide');
    $(this)
        .closest('.cart-and-ipay')
        .addClass('hide');
});

$('form.stock-notify-sign-up').on('stock-notify-sign-up:error', function(e, data) {
    csrf.updateTokens(data);
});

$('form[name="dwfrm_stockNotify"]').on('submit', function(event) {
    event.preventDefault();

    var $form = $(this);
    var url = $form.attr('action');
    var pid = $('.product-id')
        .text()
        .trim();

    if (!pid) {
        return;
    }

    var newUrl = domUtil.appendToUrl(url, { pid: pid });
    var attentiveURL = domUtil.appendToUrl($form.data('attentive-action'), { pid: pid, isPDP: true });

    $form.spinner().start();
    $.ajax({
        url: newUrl,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function(data) {
            if (!data.success) {
                $form.spinner().stop();
                formValidation($form, data);
                $('.error-msg').remove();
                if ('message' in data) {
                    $form.find('#waitListJoin').addClass('is-invalid');
                    $('#stock-notify-signup-form-email-error').empty();
                    $('#stock-notify-signup-form-email-error').prepend("<p class='error-msg' role='alert'>" + data.message + '</p>');
                }
                $('form.stock-notify-sign-up').trigger('stock-notify-sign-up:error', data);
            } else if (!$form.find('#attentive-pdp').is(':checked')) {
                $form.spinner().stop();
                $('.notify-sign-up .form-group, .notify-sign-up .btn.stock-notify-signup-email, .notify-sign-up.title').addClass('hide');
                $('.notify-sign-up .btn.stock-notify-signup-success').removeClass('hide');
            }
        },
        error: function() {
            $form.spinner().stop();
        }
    });

    if ($form.find('#attentive-pdp').is(':checked')) {
        $.ajax({
            url: attentiveURL,
            type: 'get',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                $form.spinner().stop();
                if (!data.success) {
                    formValidation($form, data);
                    $('.error-msg').remove();
                    if ('message' in data) {
                        $form.find('#smsJoin').addClass('is-invalid');
                        $('#sms-signup-form-error').empty();
                        $('#sms-signup-form-error').prepend("<p class='error-msg' role='alert'>" + data.message + '</p>');
                    }
                    $('form.stock-notify-sign-up').trigger('stock-notify-sign-up:error', data);
                } else {
                    $('.notify-sign-up .form-group, .notify-sign-up .btn.stock-notify-signup-email, .notify-sign-up.title').addClass('hide');
                    $('.notify-sign-up .btn.stock-notify-signup-success').removeClass('hide');
                }
            },
            error: function () {
                $form.spinner().stop();
            }
        });
    }
});

// remove isapplepay element on pdp for browsers that do not support it
if ('ApplePaySession' in window === false) {
    $('isapplepay').remove();
}

// page load initialization on desktop only
if (!customUtil.isMobile()) {
    setProductDetailsDescTop($('.product-detail'));

    $('body').on('click', '.product-pdp .size-attribute, .product-pdp .color-attribute', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

